import { useState } from "react"
import { Divider, WizardFooter, WizardTitle } from "@components"
import { Select, SelectItem } from "@heroui/react"
import { Cog6ToothIcon } from "@heroicons/react/24/outline"
import { AppForm, BookingConfirmationEmailForm, EmailForm } from "./Forms"
import { PropTypes } from "prop-types"

const Step1 = ({ 
  configuration, 
  handleClose, 
  handleNext, 
  notificationStatus, 
  notificationTypes, 
}) => {
  const [form, setForm] = useState(configuration)

  const handleUpdateForm = (key, value) => {
    setForm((prevForm) => ({...prevForm, [key]: value}))
  }  

  const isFormValid = () => {
    if (form?.type?.code === "APP") {
      return form.title && form.description && form.alertType && form.description.trim().length >= 10 && form.title.trim().length >= 3
    } else if (form?.type?.code === "CUSTOM_EMAIL") {
      return form.title && form.description && form.description.trim().length >= 10 && form.title.trim().length >= 3
    } else if (form?.type?.code === "BOOKING_CONFIRMATION_EMAIL") {
      return true
    }

    return false
  }

  const isNextButtonDisabled = !isFormValid()

  return (
    <div>
      <WizardTitle 
        title="Step 1 of 4 - Notification Setup"
        description="Pick the type of notification, text, subject etc."
        icon={<Cog6ToothIcon />}
      />
      
      <form className="flex flex-col gap-y-4" noValidate>
        <Select
          placeholder="Select a notification type"
          selectedKeys={form.type ? [form.type.id] : []}
          onSelectionChange={(selection) => handleUpdateForm("type", notificationTypes.find(type => type.id === selection.currentKey))}
          label="Notification Type"
          labelPlacement="outside"
          isRequired
        >
          {notificationTypes.filter(type => type.show).map((type) => (
            <SelectItem key={type.id} value={type}>
              {type.name}
            </SelectItem>
          ))}
        </Select>

        <Divider />
        
        {form?.type?.code === "BOOKING_CONFIRMATION_EMAIL" && <BookingConfirmationEmailForm form={form} handleUpdateForm={(key, value) => handleUpdateForm(key, value)} />}
        {form?.type?.code === "APP" && <AppForm form={form} handleUpdateForm={(key, value) => handleUpdateForm(key, value)} types={notificationStatus} />}
        {form?.type?.code === "CUSTOM_EMAIL" && <EmailForm form={form} handleUpdateForm={(key, value) => handleUpdateForm(key, value)} />}
      </form>
      
      <WizardFooter 
        currentStep={1} 
        totalSteps={5} 
        previousCaption="Cancel" 
        nextCaption="Select Groups" 
        isNextButtonDisabled={isNextButtonDisabled}
        handlePrevious={() => handleClose()} 
        handleNext={() => handleNext(form)} 
      />
    </div>
  )
}

Step1.propTypes = {
  configuration: PropTypes.shape({
    alertType: PropTypes.object,
    description: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.object,
  }).isRequired,
  handleClose: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
  notificationTypes: PropTypes.array.isRequired,
  notificationStatus: PropTypes.array.isRequired,
}

export default Step1
